export const translations = {
  tr: {
    nav: { services: "Hizmetler", products: "Ürünler", corporate: "Kurumsal", contact: "İletişim", cta: "Hemen Başlayın" },
    hero: {
      badge: "Yeni Nesil Kurumsal Dijital Ticaret",
      line1: "Dijital Ticaretin",
      line2: "Geleceği",
      sub: "rojdijital; vizyoner markalar için üst düzey web mimarisi, yapay zekâ entegrasyonu ve seçkin kurumsal donanımları tek bir çatı altında sunar.",
      cta1: "Kataloğu Keşfedin",
      cta2: "Kurumsal Çözümler",
      stat1: "48M₺+", stat1d: "Aylık İşlem Hacmi",
      stat2: "%99.99", stat2d: "Uptime Güvencesi",
      stat3: "240+", stat3d: "Küresel Proje",
      scroll: "Kaydır",
    },
    marquee: ["Kurumsal Mimari", "Yapay Zekâ Entegrasyonu", "Ultra-Güvenli Donanım", "Lüks E-Ticaret Altyapısı", "Global SEO Liderliği", "ISO 27001 Sertifikalı"],
    products: {
      eyebrow: "Katalog",
      title: "Seçkin Hizmetler & Donanım",
      sub: "Dijital servisler ve premium teknolojik donanımların özenle seçilmiş koleksiyonu.",
      all: "Tümü", services: "Dijital Hizmetler", hardware: "Donanım",
      add: "Sepete Ekle", added: "Eklendi", from: "başlangıç",
    },
    about: {
      eyebrow: "Kurumsal Kimlik",
      title1: "Dijital Çağda",
      title2: "Güç ve Prestij",
      desc: "rojdijital, Türkiye'nin ve dünyanın önde gelen kuruluşlarına uçtan uca dijital dönüşüm ve lüks donanım tedariği sunar. Her projede güvenlik, hız ve zarafet standarttır.",
      f1t: "Kurumsal Güvenlik", f1d: "ISO 27001 uyumlu altyapı, uçtan uca şifreleme ve 7/24 izleme.",
      f2t: "Edge Performans", f2d: "14 ülkede dağıtık mimari ile 120ms altı ortalama gecikme.",
      f3t: "Özel Mühendislik", f3d: "Her çözüm markanıza özel; şablon değil, mimari.",
      f4t: "Beyaz Eldiven Destek", f4d: "Adanmış hesap yöneticisi ve öncelikli SLA.",
      s1: "240+", s1d: "Tamamlanan Proje",
      s2: "14", s2d: "Aktif Ülke",
      s3: "<120ms", s3d: "Ortalama Gecikme",
      s4: "2016", s4d: "Kuruluş Yılı",
      quote: "“Teknolojiyi değil, güveni satıyoruz. Teknoloji sadece aracımız.”",
      quoteBy: "Kurucu Ortak, rojdijital",
    },
    cart: {
      title: "Sepetiniz", empty: "Sepetiniz boş", emptyDesc: "Kataloğumuzdan servis veya donanım ekleyerek başlayın.",
      subtotal: "Ara Toplam", vat: "KDV (%20)", total: "Genel Toplam",
      checkout: "Güvenli Sipariş Ver", clear: "Sepeti Temizle", browse: "Kataloğa Göz At",
      addedToast: "sepete eklendi", checkoutToast: "Siparişiniz alındı — ekibimiz sizinle iletişime geçecek.",
      items: "ürün",
    },
    footer: {
      tagline: "Dijital ticaretin karanlık, parlak geleceği.",
      newsTitle: "Kurumsal Bültene Katılın",
      newsDesc: "Dijital ticaret trendleri ve özel lansmanlardan ilk siz haberdar olun.",
      placeholder: "kurumsal@sirketiniz.com", subscribe: "Abone Ol", subscribed: "Teşekkürler, aboneliğiniz alındı.",
      invalid: "Geçerli bir e-posta girin.",
      col1: "Şirket", col2: "Çözümler", col3: "Yasal",
      c1: ["Hakkımızda", "Kariyer", "Basın", "İletişim"],
      c2: ["Web Mimarisi", "Yapay Zekâ", "SEO & Büyüme", "Donanım"],
      c3: ["Gizlilik", "Şartlar", "KVKK", "Çerezler"],
      rights: "Tüm hakları saklıdır.",
    },
  },
  en: {
    nav: { services: "Services", products: "Products", corporate: "Corporate", contact: "Contact", cta: "Get Started" },
    hero: {
      badge: "Next-Generation Enterprise Commerce",
      line1: "The Future of",
      line2: "Digital Commerce",
      sub: "rojdijital delivers bespoke enterprise web architecture, deep AI integration and ultra-premium technology gear for visionary brands.",
      cta1: "Explore Catalog",
      cta2: "Enterprise Solutions",
      stat1: "$48M+", stat1d: "Monthly Volume",
      stat2: "99.99%", stat2d: "Uptime SLA",
      stat3: "240+", stat3d: "Global Projects",
      scroll: "Scroll",
    },
    marquee: ["Enterprise Architecture", "AI Workflow Integration", "High-Grade Hardware", "Luxury Commerce Engines", "Global SEO Dominance", "ISO 27001 Compliant"],
    products: {
      eyebrow: "Catalog",
      title: "Curated Services & Gear",
      sub: "A hand-picked suite of enterprise digital solutions and high-performance devices.",
      all: "All", services: "Digital Services", hardware: "Hardware",
      add: "Add to Cart", added: "Added", from: "from",
    },
    about: {
      eyebrow: "Corporate Identity",
      title1: "Power & Prestige",
      title2: "in the Digital Era",
      desc: "rojdijital empowers market leaders with sovereign digital ecosystems, high-security infrastructure and bespoke executive craft. Security, speed and elegance are standard on every engagement.",
      f1t: "Enterprise Security", f1d: "ISO 27001 aligned infrastructure, end-to-end encryption and 24/7 monitoring.",
      f2t: "Edge Performance", f2d: "Sub-120ms average latency via distributed architecture across 14 countries.",
      f3t: "Bespoke Engineering", f3d: "Every solution is built for your brand — architecture, not templates.",
      f4t: "White-Glove Support", f4d: "Dedicated account director and priority SLA.",
      s1: "240+", s1d: "Projects Delivered",
      s2: "14", s2d: "Active Jurisdictions",
      s3: "<120ms", s3d: "Average Latency",
      s4: "2016", s4d: "Founded",
      quote: "“We don't sell technology. We sell trust. Technology is merely our instrument.”",
      quoteBy: "Co-Founder, rojdijital",
    },
    cart: {
      title: "Your Cart", empty: "Your cart is empty", emptyDesc: "Select elite services or devices to begin your order.",
      subtotal: "Subtotal", vat: "VAT (20%)", total: "Total",
      checkout: "Secure Checkout", clear: "Clear Cart", browse: "Browse Catalog",
      addedToast: "added to cart", checkoutToast: "Order received — our team will reach out shortly.",
      items: "items",
    },
    footer: {
      tagline: "The dark, brilliant future of digital commerce.",
      newsTitle: "Join the Executive Briefing",
      newsDesc: "Private insights on commerce infrastructure and upcoming hardware drops.",
      placeholder: "executive@enterprise.com", subscribe: "Subscribe", subscribed: "Thank you, you're subscribed.",
      invalid: "Enter a valid email address.",
      col1: "Company", col2: "Solutions", col3: "Legal",
      c1: ["About", "Careers", "Press", "Contact"],
      c2: ["Web Architecture", "AI Automation", "SEO & Growth", "Hardware"],
      c3: ["Privacy", "Terms", "GDPR", "Cookies"],
      rights: "All rights reserved.",
    },
  },
  ru: {
    nav: { services: "Услуги", products: "Продукты", corporate: "Компания", contact: "Контакты", cta: "Начать" },
    hero: {
      badge: "Корпоративная цифровая коммерция нового поколения",
      line1: "Будущее",
      line2: "цифровой коммерции",
      sub: "rojdijital предлагает индивидуальную корпоративную веб-архитектуру, глубокую интеграцию ИИ и премиальное оборудование для дальновидных брендов.",
      cta1: "Смотреть каталог",
      cta2: "Корпоративные решения",
      stat1: "$48M+", stat1d: "Месячный оборот",
      stat2: "99.99%", stat2d: "Гарантия Uptime",
      stat3: "240+", stat3d: "Глобальных проектов",
      scroll: "Листайте",
    },
    marquee: ["Корпоративная архитектура", "Интеграция ИИ", "Защищённое оборудование", "Премиум e-commerce", "Глобальное SEO-лидерство", "Сертификат ISO 27001"],
    products: {
      eyebrow: "Каталог",
      title: "Отборные услуги и оборудование",
      sub: "Тщательно подобранная коллекция цифровых сервисов и высокопроизводительных устройств.",
      all: "Все", services: "Цифровые услуги", hardware: "Оборудование",
      add: "В корзину", added: "Добавлено", from: "от",
    },
    about: {
      eyebrow: "Корпоративная идентичность",
      title1: "Сила и престиж",
      title2: "в цифровую эпоху",
      desc: "rojdijital предоставляет лидерам рынка суверенные цифровые экосистемы, высокозащищённую инфраструктуру и индивидуальные решения. Безопасность, скорость и элегантность — стандарт в каждом проекте.",
      f1t: "Корпоративная безопасность", f1d: "Инфраструктура по ISO 27001, сквозное шифрование и мониторинг 24/7.",
      f2t: "Edge-производительность", f2d: "Средняя задержка менее 120 мс благодаря распределённой архитектуре в 14 странах.",
      f3t: "Индивидуальная инженерия", f3d: "Каждое решение создаётся под ваш бренд — архитектура, а не шаблоны.",
      f4t: "Поддержка премиум-класса", f4d: "Персональный менеджер и приоритетный SLA.",
      s1: "240+", s1d: "Реализованных проектов",
      s2: "14", s2d: "Активных стран",
      s3: "<120ms", s3d: "Средняя задержка",
      s4: "2016", s4d: "Год основания",
      quote: "«Мы продаём не технологии. Мы продаём доверие. Технология — лишь наш инструмент.»",
      quoteBy: "Сооснователь, rojdijital",
    },
    cart: {
      title: "Ваша корзина", empty: "Корзина пуста", emptyDesc: "Выберите услуги или устройства, чтобы начать заказ.",
      subtotal: "Промежуточный итог", vat: "НДС (20%)", total: "Итого",
      checkout: "Оформить заказ", clear: "Очистить корзину", browse: "Открыть каталог",
      addedToast: "добавлено в корзину", checkoutToast: "Заказ получен — наша команда скоро свяжется с вами.",
      items: "товаров",
    },
    footer: {
      tagline: "Тёмное, блистательное будущее цифровой коммерции.",
      newsTitle: "Подпишитесь на рассылку",
      newsDesc: "Эксклюзивные материалы об инфраструктуре коммерции и новинках оборудования.",
      placeholder: "executive@enterprise.com", subscribe: "Подписаться", subscribed: "Спасибо, вы подписаны.",
      invalid: "Введите корректный email.",
      col1: "Компания", col2: "Решения", col3: "Правовая информация",
      c1: ["О нас", "Карьера", "Пресса", "Контакты"],
      c2: ["Веб-архитектура", "Автоматизация ИИ", "SEO и рост", "Оборудование"],
      c3: ["Конфиденциальность", "Условия", "GDPR", "Cookies"],
      rights: "Все права защищены.",
    },
  },
};
